// extracted by mini-css-extract-plugin
export default {"mainContainer":"LanguageDialogConfirmation_mainContainer__JBGC8","buttonsContainer":"LanguageDialogConfirmation_buttonsContainer__NIIEZ"};